<template>
   <div style="margin-left: 30px;">
        <el-menu style="margin-top: -20px;" :default-active="activeIndex"  class="el-menu-vertical-demo" mode="horizontal" @select="handleOpen"  >
            <el-menu-item index="0">
                <span>基本设置</span>
            </el-menu-item>
            <el-menu-item index="1">
                <span>额度设置</span>
            </el-menu-item>
            <el-menu-item index="2" router="true">
                <span slot="title">版本绑定</span>
            </el-menu-item>
            <el-menu-item index="7">
                <span slot="title">地区试卷的地区绑定</span>
            </el-menu-item>
            <el-menu-item index="3" >
                <span slot="title">应用绑定</span>
            </el-menu-item>
            <el-menu-item index="4">
                <span slot="title">最大空间设置</span>
            </el-menu-item>
            <el-menu-item index="8">
                <span slot="title">模块绑定</span>
            </el-menu-item>
            <el-menu-item index="6">
                <span slot="title">修改记录</span>
            </el-menu-item>

            <el-tooltip class="item" effect="light" placement="top" :value="true">
                <div slot="content" style="color: #F56C6C;font-size: 14px"><b><i class="el-icon-message-solid"></i>修改配置后请点击此处保存</b></div>
                <TemporaryLimit v-if="is_temporary" style="text-align: center;float: right;margin-top: 26px" buttonName="确定" @change="submit"></TemporaryLimit>
                <el-button v-else style="text-align: center;float: right;margin-top: 26px" type=primary size="small" @click="submit()" :loading="is_submit">确定</el-button>
            </el-tooltip>
        </el-menu>
       <el-row class="tac">
            <basic-configure v-if="activeIndex == 0 " :head_params="params" :params="form.basic_configure" ref="basic-configure" :domain_suffix="domain_suffix" @handleDataInit='handleDataInit'>
                <template slot="head">
                    <product-head :params="params" @changeHead="changeHead"></product-head>
                </template>
            </basic-configure>
            <div v-if="activeIndex==6">
                <recorder :customer_id="$route.query['id']" :product_id="form.product_id" :product_list="params.product_list"></recorder>
            </div>
            <div v-if="activeIndex==1">
                <p style="color:red;font-size:16px;">
                    提示：校本资源库额度与校网通学校风险控制额度通用，必须先开通校网通才能下载，请前往“校网通”设置额度
                </p>
            </div>
            <!-- <limit-configure v-show="activeIndex == 1" :type="params.open_state" :params="form.limit_configure" :hidden="true" @handleSubmitLimitConfigure='handleSubmitLimitConfigure'></limit-configure> -->
            <version-bind  v-if="activeIndex == 2 " :customer_id="params.customer_id" :params="form.version_bind" @handleSubmitVersionBind='handleSubmitVersionBind'></version-bind>
            <div v-if="activeIndex == 7"  class="demo-input-suffix">
                <p class="exp">注意事项：当前模块控制 校本-本校资源-地区试卷的左侧目录树的地区、学校展示隐藏</p>
                <el-menu :default-active="eliteShcoolIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                <el-menu-item index="1">资源地区绑定</el-menu-item>
                <el-menu-item index="2">屏蔽学校</el-menu-item>
                </el-menu>
                <el-row :gutter="10" v-if="eliteShcoolIndex == 1">
                    <el-col :span="10">
                        <div class="grid-content">
                            <el-scrollbar style="height:100%">
                                <elite-school-area v-if="activeIndex == 7 " :customer_id="$route.query['id']" :customer="params.customer">
                                </elite-school-area>
                            </el-scrollbar>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="10" v-if="eliteShcoolIndex == 2">
                    <el-col :span="3">
                        <el-button style="text-align: center;margin-top: 20px;margin-bottom: 20px;" type=primary size="small" @click="dialogTableVisible = true">+屏蔽学校</el-button>
                        <p style="float: right;font-size: small;">已屏蔽学校：</p>
                    </el-col>
                    <el-col :span="21">
                        <div class="grid-content" style="margin-top: 60px;">
                            <el-scrollbar style="height:100%">
                                <hide-school v-if="activeIndex == 7 " :customer_id="$route.query['id']" :params="form.limit_configure">
                                </hide-school>
                            </el-scrollbar>
                        </div>
                        <!-- 线索查重 -->
                        <elite-school v-if="dialogTableVisible" :display="dialogTableVisible" :customer="params.customer" :customer_id="$route.query['id']" @watchQueryRepeatClose="watchQueryRepeatClose"></elite-school>
                    </el-col>
                </el-row>
            </div>
            <app-bind v-if="activeIndex == 3 " :params="form.app_bind" @handleSubmitAppBind='handleSubmitAppBind' :app_data="app_data"></app-bind>
            <div v-if="activeIndex == 4"  class="demo-input-suffix">
                <el-row>
                    <el-form  :model="form" label-width="100px" class="demo-ruleForm">
                        <el-form-item
                                label="最大空间设置"
                                prop="max_setting"
                                :rules="[
                                { type: 'number', message: '必须为数字值'}
                            ]"
                        >
                            <el-input  placeholder="请输入数字" v-model.number="form.max_setting"
                        size="mini" >
                            </el-input>
                        </el-form-item>

                    </el-form>
                </el-row>
                <p class="exp">说明：-1禁用,0不限,大于0：具体额度</p>
                <span class="exp">注：容量以G为单位计算，这里只限制校本资源3.0本地学校上传资源</span>
            </div>
            <div v-if="activeIndex == 5">
                <relation-form service="jb3" ref="relation-form" :customerId="$route.query['id']" already-relation="true">
                    <template slot="button">
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="mini" @click="showRelation=true">关联账号</el-button>
                        <relation-dialog service="jb3" title="关联账号" @relationAccount="relationAccount" @handleClose="closeRelationDialog" :customerId="$route.query['id']" :is-show="showRelation" ></relation-dialog>
                    </template>
                </relation-form>
            </div>
            <module-bind v-show="activeIndex == 8 " :params="form.module_bind" @handleSubmitModuleBind='handleSubmitModuleBind'></module-bind>
        </el-row>
   </div>
</template>

<style scoped>
    .app-main .main-bd .el-row {
        padding: 10px 0;
    }
    .exp {
        color: red;
    }
    .grid-content {
        height: 700px;
    }
</style>
<script>
// import LimitConfigure from  "~/views/order/jiaoben/limitConfigure.vue";
import VersionBind from  "~/views/order/jiaoben/versionBind.vue";
import AppBind from  "~/views/order/jiaoben/appBind.vue";
import ModuleBind from  "~/views/order/jiaoben/moduleBindXb3.vue";
import BasicConfigure from  "~/views/order/jiaoben/basicConfigure.vue";
import EliteSchool from  "~/views/order/jiaoben/eliteSchool.vue";
import HideSchool from  "~/views/order/jiaoben/hideSchool.vue";
import EliteSchoolArea from  "~/views/order/jiaoben/eliteSchoolArea.vue";
import CommonService from "~/services/common";
import RelationForm from "~/views/customer/relationForm.vue";
import RelationDialog from "~/views/customer/dialog/relationDialog.vue";
import Params from "~/config/params";
import OrderService from "~/services/order";
import ProductHead from  "~/views/order/partial/product_head.vue";
import Recorder from "~/views/order/recoder/base.vue";
import TemporaryLimit from "~/views/order/dialog/temporaryLimit.vue";

export default {
    components:{
        ProductHead,
        // LimitConfigure,
        VersionBind,
        AppBind,
        ModuleBind,
        BasicConfigure,
        CommonService,
        RelationForm,
        RelationDialog,
        Recorder,
        EliteSchool,
        EliteSchoolArea,
        HideSchool,
        TemporaryLimit
    },
    data() {
        return {
            form:{
                order_id:'',
                product_id:'',
                version_bind:"",
                app_bind:[],
                basic_configure:"",
                limit_configure:"",
                max_setting:'',
                module_bind: [],
                expire_type: ''
            },
            is_submit:false,
            showRelation:false,
            is_ajax_loading:false,
            validate_basic_configure:true,
            app_data:[],
            domain_suffix:'xbzyk.com',
            activeIndex:'0',
            formLabelWidth:'120px',
            eliteShcoolIndex: '1',
            dialogTableVisible: false,
            isFormModified: false,
            is_temporary: false,
        };
    },
    props:{
        params:{
            required:true
        }
    },
    mounted() {
        this.getApp();
    },
    created(){
        this.form = Object.assign(this.form,this.params.config)
        this.form.order_id = this.params.order_id;
        this.form.product_id = this.params.product_id;
        this.form.type = this.params.open_state;
        this.form.end_at = this.params.end_at;
        this.form.start_at = this.params.start_at;
        setTimeout(() => {
            this.isFormModified = true;
        });
    },
    watch: {
        'form.limit_configure.day': {
            handler(newVal, oldVal) {
                this.watchForm(newVal, oldVal);
            },
            deep: true, // 深度监听，确保内部属性变化也能触发
        },
        'form.limit_configure.user_common_quota': {
            handler(newVal, oldVal) {
                this.watchForm(newVal, oldVal);
            },
            deep: true, // 深度监听，确保内部属性变化也能触发
        },
    },
    methods:{
        watchForm(newVal, oldVal){
            if (this.isFormModified) {
                // 在这里执行你需要的操作，比如更新其他数据或调用方法
                this.is_temporary = true;
            }else{
            }
        },
        /**
         * 修改头部信息
         * @param data
         */
        changeHead(data){
            this.form.type = data.type;
            this.form.end_at = data.end_at;
            this.form.start_at = data.start_at;
        },
        /**
         * 提交表单
         * */
        submit(expire_type = ''){
            if(this.is_submit) return false;
            if(!this.validate_basic_configure) return false;
            if (this.form.module_bind.length == 0) {
                this.$message({
                    message: "请选择模块配置",
                    type: 'error'
                });
                return false;
            }
            this.is_submit = true;
            this.form.expire_type = expire_type;
            OrderService.reviseProduct(this.form).then(res => {
                if (res.code == 0) {
                    this.$message({
                        message: res.msg=='success'?Params.REVISE_NOTICE:res.msg,
                        type: 'success'
                    });
                }
                this.is_temporary = false;
                this.is_submit = false;
            }).catch(() => {
                this.$message({
                    type: "error",
                    message: "操作失败"
                });
                this.is_submit = false;
            });
        },
        closeRelationDialog(show){
            this.showRelation = show;
        },
        /**
         * 关联账号
         * */
        relationAccount(data){
            this.$refs['relation-form'].getAlready();
        },
        handleDialogConfigureClose(){
            this.$emit('handleDialogConfigureShow','',this.form.product_id);
        },
        handleDialogConfigureShow(){
            if(!this.validate_basic_configure){
                this.$message({
                    message:'请进行基本设置或者基本设置有误',
                    type:'error'
                })
                return false;
            }
            this.$emit('handleDialogConfigureShow',this.form);

        },
        handleOpen(key, keyPath) {
            if(key==5){
                return false;
            }
            this.activeIndex = key;
        },
        handleSubmitVersionBind(params){
            this.form.version_bind = params;
        },
        handleSubmitAppBind(params){
            this.form.app_bind = params;
        },
        handleSubmitLimitConfigure(params){
            this.form.limit_configure = params;
        },
        handleDataInit(data){
            this.is_ajax_loading = true;
            this.$refs['basic-configure'].validateForm((rs)=>{
                this.validate_basic_configure = rs;
                this.is_ajax_loading = rs;
            })
            this.form.basic_configure = data;
        },
        getApp(){
            //改成与校本资源库一致
            CommonService.getJbtAPP({customer_id:this.$route.query['id']}).then(res=>{
                this.app_data = res.data;
            })
            //获取数字化学校应用
            // CommonService.getJbApp().then(res=>{
            //     this.app_data = res.data;
            // })
        },

        /** 获取学校开通产品的信息 */
        getProductInfo(){
            CommonService.getSchoolProductInfo({customer_id:global.customer_id,product:this.params.code}).then(res=>{
                if(res.data){
                    this.form.basic_configure.cor_domain = res.data.domain_url.split('.')[0];
                    this.form.basic_configure.cor_domain_url = res.data.domain_url;
                    if(res.data.logo_url){
                        this.form.basic_configure.fileList = [{name:'学校Logo展示图片',url:res.data.logo_url}];
                    }
                    this.validate_basic_configure = true;
                }
            })
        },

        handleSelect(key, keyPath) {
            this.eliteShcoolIndex = key;
        },

        watchQueryRepeatClose() {
            this.dialogTableVisible = false;
        },

        handleSubmitModuleBind(params) {
            this.form.module_bind = params;
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/views/order/jiaoben/configureV3.vue